/* SLIDE 17 */

import React, { useState } from "react";
import ButtonBot from "shared/components/ButtonBot";
import AppInfoRow from "shared/components/AppInfoRow";
import Popup from "shared/components/Popup";
import SubHeader from "shared/components/SubHeader";
import checkIcon from "assets/icons/checkIcon.svg";
import closeIcon from 'assets/icons/close.svg';

function ParkingPayment() {
    const [showPopup, setShowPopup] = useState(false);

    return (
        <div className="htContainer">
            <SubHeader>
                <div
                    className={`sub-header-text w-full justify-between`}
                >
                    <div className="nl-row">   
                        <img src={checkIcon} alt="Camera" />
                        <span className="ml-5 htBold htColorMain">결제완료</span>
                    </div>
                    <div>
                        <span className="sub-header-btn">출차</span>
                    </div>

                </div>
            </SubHeader>

            <div className="htContent htHasButtonBot mn-payment-complete">
                <div className="htSection">
                    <h2>차량정보</h2>
                    <AppInfoRow label="차량번호" value="152가 2045" />
                    <AppInfoRow label="입차일시" value="2024-11-20 13:15" />
                    <AppInfoRow label="출차일시" value="2024-11-20 13:15" />
                    <AppInfoRow label="결제요금" value="2,000원" />
                </div>
                <div className="htSeparator"></div>

                <div className="htSection">
                    <h2>결제요금</h2>
                    <AppInfoRow label="결제카드" value="현대카드" valueClass="htBold" />
                    <AppInfoRow label="" value="114354 *** 1234" valueClass="htBold" />
                    <div className="htInfoRow">
                        <h2>결제금액</h2>
                        <h2 className="htIrValue htColorMain">4,500원</h2>
                    </div>
                    <AppInfoRow label="상품명" value="서울특별시 송파구시설관리공단" />
                    <AppInfoRow label="승인번호" value="00712341234" />
                    <AppInfoRow label="거래일시" value="2024-11-20 15:15:00" />

                    <div className="htInfoRow htBold">
                        <span className="">결제금액</span>
                        <span className="htTotal">2,500원</span>
                    </div>
                </div>
                <div className="htSeparator" style={{marginBottom: '30px'}}></div>
                <button className="htSubmitButton" style={{fontWeight: "400"}}>결제내역 재발급</button>

                <ButtonBot textYes={`홈으로`} handleYes={() => setShowPopup(true)} />
                {showPopup && (
                    <Popup handleYes={() => setShowPopup(false)} title="결제 확인" textYes="아니오 <br/> (미납처리)"  textNo="예 <br/>(결제하기)"  setVisible={setShowPopup}>
                        <div className="htPpCamera my-3">
                            <p>결제를 진행하시겠습니까?</p>
                            <p>(결제 미진행 시 미납처리)</p>
                        </div>
                      
                    </Popup>
                )}
            </div>
        </div>
    );
}

export default ParkingPayment;
